module.exports = __webpack_public_path__ + "static/media/audio_player.4c1eeb0e.svg";